<template>
  <div id="cardapioescola">
    <v-layout class="mt-5 mb-2">
      <v-flex xs2 class="mr-3">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
        ></v-select>
      </v-flex>
      <v-flex xs6>
        <v-autocomplete
          v-model="searchSelected"
          :items="buscaCardapiosEscolas"
          :hide-no-data="!search && buscaCardapiosEscolas.length == 0 && !buscarLoading"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${search}'`"
          outlined
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          :search-input.sync="search"
          @keydown="buscar()"
          :loading="buscarLoading"
          @change="encontrado"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <FormBasico
      :acao="acao"
      :id="form.identificadorcardapioescola"
      :novo="novoCardapioEscola"
      :editar="() => {}"
      :excluir="excluirCardapioEscola"
      :cancelar="cancelarCardapioEscola"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaCardapioEscola">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col lg="7">
              <v-text-field label="Código Cardápio/Unidade Escolar" v-model="form.identificadorcardapioescola" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.anoletivo">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  :items="anoOptions"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  outlined
                  label="Ano Letivo*"
                  no-data-text="Opções não disponíveis"
                  v-model="$v.form.anoletivo.$model"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.identificadortitulocardapio">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadortitulocardapio"
                  :items="cardapioOptions"
                  item-text="descricaotitulocardapio"
                  item-value="identificadortitulocardapio"
                  outlined
                  multiple
                  small-chips
                  deletable-chips
                  label="Título Cardápio*"
                  :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' : cardapioSearch ? `Nenhuma opção encontrada com '${cardapioSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="cardapioSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="cardapiosLoading && (acao == 'novo' || acao == 'editar')"
                  loader-height="3"
                  @focus="loadCardapioOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.identificadorescolalocalexterno">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorescolalocalexterno"
                  :items="escolaOptions"
                  item-text="nomeescola"
                  item-value="identificadorescolalocalexterno"
                  outlined
                  multiple
                  small-chips
                  deletable-chips
                  label="Unidade Escolar*"
                  :no-data-text="escolasLoading ? 'Carregando dados, aguarde...' : escolaSearch ? `Nenhuma opção encontrada com '${escolaSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="escolaSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="escolasLoading && (acao == 'novo' || acao == 'editar')"
                  loader-height="3"
                  @focus="loadEscolaOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { required, integer, alphaNum, array } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const TituloCardapioRepository = RepositoryFactory.get("tituloCardapio");
const EscolaRepository = RepositoryFactory.get("escola");
const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");

const setFormInicial = () => ({
  identificadorcardapioescola: '',
  anoletivo: null,
  identificadortitulocardapio: [],
  identificadorescolalocalexterno: [],
});

export default {
  name: 'CardapioEscola',
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      loading: false,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaotitulocardapio',
      buscaOptions: [
        { value: 'descricaotitulocardapio', text: 'Descrição cardápio/unidade escolar' },
      ],
      buscaCardapiosEscolas: [],
      cardapioOptions: [],
      cardapiosLoading: false,
      escolaOptions: [],
      escolasLoading: false,
      searchSelected: '',
      search: '',
      cardapioSearch: '',
      escolaSearch: '',
      buscarLoading: false,
      formUltimo: {},
    };
  },
  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema']),

    anoOptions() {
      let retornoOptions = [];
      for(let i = new Date().getFullYear() + 1; i >= 2023; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir' || this.isFormLoading
    },
    isFormLoading() {
      return this.loading
    },
  },
  validations: {
    form: {
      anoletivo: { required, integer },
      identificadortitulocardapio: {
        required,
        $each: {
          integer,
        }
      },
      identificadorescolalocalexterno: {
        required,
        $each: {
          alphaNum
        }
      },
    }
  },
  async mounted() {
    this.$Progress.finish();
  },
  methods: {
    tabelaCardapioEscola() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Cardápio/Unidade Escolar / Listar',
          rota_api: 'merenda/cardapio-escola/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorcardapioescola', sortable: false },
                    { text: 'Ano Letivo', value: 'anoletivo', sortable: false },
						        { text: 'Título Cardápio', value: 'descricaotitulocardapio', sortable: false },
                    { text: 'Unidade Escolar', value: 'nomeescola', sortable: false }],
        },
      });
    },
    novoCardapioEscola() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
    },
    cancelarCardapioEscola() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.loading = false;
      this.cardapiosLoading = false;
      this.escolasLoading = false;
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirCardapioEscola() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este registro cardápio/unidade escolar?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          const { data } = await CardapioEscolaRepository.deletarCardapioEscola(this.form.identificadorcardapioescola);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
          this.buscaCardapiosEscolas = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
      this.loading = false;
      this.acao = '';
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.loading = true
      this.msgArrayError = []

      try {
        const { data } = await CardapioEscolaRepository[this.acao === 'novo' ? 'criarCardapioEscola' : 'editarCardapioEscola'](this.form);
        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.form.anoletivo = parseInt(this.form.anoletivo);
        this.formUltimo = { ...this.form };
        this.$v.$reset()
        this.buscaCardapiosEscolas = []
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE_DUPLICATION') {
          this.msgArrayError = error.response.data.errorMessage.map(e => `Já existe uma associação entre ${e.descricaotitulocardapio} e ${e.nomeescola}`)
        }
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
    encontrado(dados) {
      this.form = setFormInicial();
      let dado = this.buscaCardapiosEscolas.find(e => e.value == dados);
      this.form = { ...dado, identificadorcardapioescola: dado.value };
      this.formUltimo = { ...dados };
      this.$nextTick(() => {
        this.searchSelected = null;
        this.search = '';
      });
      this.acao = '';

    },

    async loadCardapioOptions() {
      if (this.cardapioOptions.length) {
        return
      }

      this.cardapiosLoading = true
      //await new Promise(resolve => setTimeout(resolve, 1000))
      const { data } = await TituloCardapioRepository.buscarCardapios();
      for (const key of data.results) {
        this.cardapioOptions.push({ identificadortitulocardapio: key.identificadortitulocardapio, descricaotitulocardapio: key.descricaotitulocardapio })
      }
      this.cardapiosLoading = false
    },

    async loadEscolaOptions() {
      if (this.escolaOptions.length) {
        return
      }

      this.escolasLoading = true
      const { data } = await CardapioEscolaRepository.recebeMerenda();
      for (const key of data.results) {
        this.escolaOptions.push({ identificadorescolalocalexterno: key.identificadorescolalocalexterno, nomeescola: key.identificadorescolalocalexterno.slice(0, -1) + ' - ' + key.nomeescola })
      }
      this.escolasLoading = false
    },

    async buscar() {
      if (this.buscaCardapiosEscolas.length || this.buscarLoading) return
      this.buscarLoading = true
      this.loadCardapioOptions();
      this.loadEscolaOptions();

      const { data } = await CardapioEscolaRepository.buscarCardapioEscola();
      for (const key of data.results) {
        this.buscaCardapiosEscolas.push({
          value: key.identificadorcardapioescola,
          text: `${key.anoletivo} - ${key.descricaotitulocardapio}/${key.nomeescola}`,
          anoletivo: parseInt(key.anoletivo),
          identificadortitulocardapio: parseInt(key.identificadortitulocardapio),
          identificadorescolalocalexterno: key.identificadorescolalocalexterno })
      }

      this.buscarLoading = false
    }
  },
};
</script>

<style scoped>
::v-deep #btn-acoes-t button:nth-child(2) {
  display: none !important;
}
</style>
